// Base / production environment. Used directly by the `production` build
// (no fileReplacement). The `local` and `dev` configurations swap this file for
// environment.local.ts / environment.dev.ts respectively (see angular.json).
// Zoom Meeting SDK credentials are NOT here — see
// src/app/pages/caira-ready/zoom/zoom.credentials.ts.
export const environment = {
  production: true,
  cmaapiUrl: "https://cma-api.mileseducation.com/", // CMA
  apiUrl: "https://cpa-api.mileseducation.com/", // CPA
  // Miles AI Labs — Azure sign-in via Supabase Auth. anon/publishable key only
  // (never service_role — that key would ship in the browser bundle and bypass
  // row-level security). labsCopilotUrl is the external co-pilot environment the
  // Launch button opens.
  supabaseUrl: "https://nhohkxpcoeyerzsybipo.supabase.co",
  supabaseKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5ob2hreHBjb2V5ZXJ6c3liaXBvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUyMzYxMDYsImV4cCI6MjEwMDgxMjEwNn0.Dk5XMoNG3oBVXhlUbh_zqzbJX3uMbf8h2kjNwjGXJ2c",
  labsCopilotUrl: "https://copilotstudio.microsoft.com/",
  /**
   * Home realm hint for lab accounts — forwarded verbatim to Entra by
   * Supabase as `domain_hint`.
   *
   * ⚠️ NOT optional. This is the tenant id of the directory that owns the
   * app registration behind Supabase's Azure provider (mileslabs.ai).
   * Without it Entra picks the home realm from whatever Microsoft session
   * the browser already has, so a learner signed into a different tenant
   * authenticates as a GUEST of that app rather than as the account the
   * labs backend provisioned — and nothing downstream recognises them.
   *
   * Same value the Masterclass front end sends for the same project.
   */
  labsTenantId: "f133522a-779a-4a85-bebb-e72cd0daaa1d",

  masterApiUrl: "https://masterclass-dev.miles-api.com/api/",
  // cairaUrl: "https://miles.one/", // Direct URL in production
  cairaUrl: "https://api.milescaira.com/", // Direct URL in production

  // Base URL for the QR / phone login endpoints (qr/initiate, qr/confirm).
  qrLoginUrl: "https://api.milescaira.com/",

  // Deep-link the QR encodes (format from the MilesOne app team). The app
  // recognises this URL and reads the session id from the `session` query
  // param. Final value: {qrScanBaseUrl}?session={session_id}
  qrScanBaseUrl: "https://mileseducation.com/milesone/app/web_login/",

  // New CAIRA backend (progress / get_all_badges_V4, etc.).
  cairaProgressUrl: "https://api.milescaira.com/",

  // Where a small-screen user is told to open the LMS instead (see the device
  // gate). NOT derived from window.location: the point is to name the canonical
  // address they should type on their tablet or laptop, which is not necessarily
  // the host they happen to be on — a UAT build, a preview URL or a dev server
  // would otherwise print an address that means nothing to them.
  cairaLoginUrl: "https://caira.mileseducation.com/login",

  firebase: {
    apiKey: "AIzaSyArkO_mN7VjYrtmtUsp6eMqga-aahNftCo",
    authDomain: "miles-firebase-projects.firebaseapp.com",
    projectId: "miles-firebase-projects",
    storageBucket: "miles-firebase-projects.appspot.com",
    messagingSenderId: "756926493455",
    appId: "1:756926493455:web:cd7ccbd72a3cb1dbe0047a",
    measurementId: "G-0Y63HJBX5T",
  },
};
